module.exports = __webpack_public_path__ + "img/legal-expenses-2.d3d76fc5.png";